/*
 * @Description: 配置
 * @Author:
 * @Date: 2022-09-21 22:17:23
 * @LastEditors: PF
 */
import axios from 'axios'
import { warningPrompt, errorPrompt } from '../utils/promptInfo'
import { backToLogin } from '../utils/login.js'
import { ElMessageBox } from 'element-plus'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API
})

// 请求拦截器
service.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
  // 如果是 FormData，就不设置 Content-Type，让浏览器自己处理
    delete config.headers['Content-Type']
  }
  if ($cookies.get(process.env.VUE_APP_BASE_TOKEN)) {
    config.headers.accesscode = $cookies.get(process.env.VUE_APP_BASE_TOKEN)
    return config
  } else {
    backToLogin()
  }
}, (error) => {
  return Promise.reject(error)
})

// 响应拦截
service.interceptors.response.use((response) => {
  const meta = response.data
  // console.log('response', response)
  if (meta.code === 200) {
    return meta
  } else if (meta.code === 500) {
    if (meta.message) {
      return meta
    } else {
      warningPrompt('应用程序错误，未返回信息')
    }
  } else if (meta.code === 999) {
    if (meta.message === null) {
      backToLogin()
    }
    return meta
  } else {
    return warningPrompt('code不符合规范')
  }
}, (error) => {
  // console.log('error', error)
  if (error.response.status === 5001) {
    // 创建一个 Blob 对象，包含要下载的数据
    const blob = new Blob([error.response.data], { type: 'text/plain' })
    // 创建一个指向 Blob 对象的 URL
    const url = URL.createObjectURL(blob)
    // 创建一个临时的 a 标签来触发下载
    const a = document.createElement('a')
    a.href = url
    a.download = '错误数据' + Date.now() + '.txt' // 设置下载文件的名称
    a.style.display = 'none' // 隐藏 a 标签

    // 将 a 标签添加到文档中，并模拟点击事件来触发下载
    document.body.appendChild(a)
    a.click()
    // 清理：移除 a 标签，并释放 Blob 对象占用的资源
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
    return warningPrompt(error.response.data)
  } else {
    return errorPrompt(error)
  }
})
export default service
